import { Users, Phone } from "lucide-react";

import { memo, useRef, useState } from "react";

const FiltersList = ({ users, tags, funnels, filters, onChange }) => {
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showTagDropdown, setShowTagDropdown] = useState(false);
  const [showFunnelDropdown, setShowFunnelDropdown] = useState(false);

  const userDropdownRef = useRef(null);
  const tagDropdownRef = useRef(null);
  const funnelDropdownRef = useRef(null);

  return (
    <div className="mb-4 grid grid-cols-1 gap-2">
      <div className="relative">
        <Users className="absolute left-3 top-3 h-4 w-4 text-gray-400 dark:text-gray-300" />

        <input
          type="text"
          placeholder="Buscar pelo nome..."
          className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-4 text-gray-900 placeholder-gray-400 outline-none transition-colors duration-200 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
          value={filters.name}
          onChange={(e) => onChange("name", e.target.value)}
        />
      </div>

      <div className="relative">
        <Phone className="absolute left-3 top-3 h-4 w-4 text-gray-400 dark:text-gray-300" />

        <input
          type="text"
          placeholder="Buscar pelo telefone..."
          className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-4 text-gray-900 placeholder-gray-400 outline-none transition-colors duration-200 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
          value={filters.phone}
          onChange={(e) => onChange("phone", e.target.value)}
        />
      </div>

      {/* Filtro de Users */}
      <div className="relative" ref={userDropdownRef}>
        <button
          onClick={() => {
            setShowUserDropdown((prev) => !prev);
            setShowTagDropdown(false);
            setShowFunnelDropdown(false);
          }}
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-900 outline-none transition-colors duration-200 hover:bg-gray-50 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600"
        >
          {filters.users.length === 0
            ? "Todos os Users"
            : `${filters.users.length} usuário(s) selecionado(s)`}
        </button>

        {showUserDropdown && (
          <div className="absolute z-10 mt-1 w-full rounded-lg border border-gray-300 bg-white shadow-lg dark:border-gray-600 dark:bg-gray-700">
            <div className="max-h-48 overflow-y-auto p-2">
              {users.map((user) => (
                <label
                  key={user.id}
                  className="flex cursor-pointer items-center space-x-2 rounded px-2 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <input
                    type="checkbox"
                    checked={filters.users.includes(user.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onChange("users", [...filters.users, user.id]);
                      } else {
                        onChange(
                          "users",
                          filters.users.filter((id) => id !== user.id),
                        );
                      }
                    }}
                    className="h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-2 focus:ring-green-500"
                  />
                  <span className="text-sm text-gray-900 dark:text-gray-100">
                    {user.name}
                  </span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Filtro de Tags */}
      <div className="relative" ref={tagDropdownRef}>
        <button
          onClick={() => {
            setShowTagDropdown((prev) => !prev);
            setShowUserDropdown(false);
            setShowFunnelDropdown(false);
          }}
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-900 outline-none transition-colors duration-200 hover:bg-gray-50 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600"
        >
          {filters.tags.length === 0
            ? "Todas as Tags"
            : `${filters.tags.length} tag(s) selecionada(s)`}
        </button>

        {showTagDropdown && (
          <div className="absolute z-10 mt-1 w-full rounded-lg border border-gray-300 bg-white shadow-lg dark:border-gray-600 dark:bg-gray-700">
            <div className="max-h-48 overflow-y-auto p-2">
              {tags.map((tag) => (
                <label
                  key={tag.id}
                  className="flex cursor-pointer items-center space-x-2 rounded px-2 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <input
                    type="checkbox"
                    checked={filters.tags.includes(tag.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onChange("tags", [...filters.tags, tag.id]);
                      } else {
                        onChange(
                          "tags",
                          filters.tags.filter((id) => id !== tag.id),
                        );
                      }
                    }}
                    className="h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-2 focus:ring-green-500"
                  />
                  <span
                    className="flex items-center space-x-2 text-sm"
                    style={{
                      color: tag.textColor,
                    }}
                  >
                    <span
                      className="h-3 w-3 rounded-full"
                      style={{ backgroundColor: tag.backgroundColor }}
                    />
                    <span className="text-gray-900 dark:text-gray-100">
                      {tag.name}
                    </span>
                  </span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Filtro de Funis */}
      <div className="relative" ref={funnelDropdownRef}>
        <button
          onClick={() => {
            setShowFunnelDropdown((prev) => !prev);
            setShowUserDropdown(false);
            setShowTagDropdown(false);
          }}
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-900 outline-none transition-colors duration-200 hover:bg-gray-50 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600"
        >
          {filters.steps.length === 0
            ? "Todos os Funis"
            : `${filters.steps.length} funil(is) selecionado(s)`}
        </button>

        {showFunnelDropdown && (
          <div className="absolute z-10 mt-1 w-full rounded-lg border border-gray-300 bg-white shadow-lg dark:border-gray-600 dark:bg-gray-700">
            <div className="max-h-48 overflow-y-auto p-2">
              {funnels.map((funnel) => (
                <div key={funnel.id} className="mb-2">
                  {/* Nome do funil */}
                  <div className="px-2 py-1 text-sm font-medium text-gray-900 dark:text-gray-100">
                    {funnel.name}
                  </div>

                  {/* Lista de steps do funil */}
                  {funnel.steps.map((step) => {
                    const isChecked = filters.steps.includes(step);

                    return (
                      <label
                        key={step}
                        className="flex cursor-pointer items-center space-x-2 rounded px-2 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={(e) => {
                            if (e.target.checked) {
                              onChange("steps", [...filters.steps, step]);
                            } else {
                              onChange(
                                "steps",
                                filters.steps.filter((s) => s !== step),
                              );
                            }
                          }}
                          className="h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-2 focus:ring-green-500"
                        />
                        <span className="text-sm text-gray-900 dark:text-gray-100">
                          {step}
                        </span>
                      </label>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Filtro de Status (mantido como select) */}
      <select
        className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 outline-none transition-colors duration-200 focus:border-green-500 focus:ring-2 focus:ring-green-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
        value={filters.status}
        onChange={(e) => onChange("status", e.target.value)}
      >
        <option value="">Todos os Status</option>
        <option value="ABERTO">ABERTO</option>
        <option value="ATENDIMENTO">ATENDIMENTO</option>
        <option value="AGUARDANDO">AGUARDANDO</option>
        <option value="RESOLVIDO">RESOLVIDO</option>
        <option value="FECHADO">FECHADO</option>
        <option value="ARQUIVADO">ARQUIVADO</option>
        <option value="INDEFINIDO">INDEFINIDO</option>
      </select>
    </div>
  );
};

export default memo(FiltersList);
